module.exports = __webpack_public_path__ + "static/media/artfia_logo.268ddbb6.png";